import React, { useMemo } from 'react';
import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import { hasResource } from 'utils/resourceAuth';
import { ResourceCode } from 'constants/resourceCodes';
import TransactionFlowPage from './TransactionFlowPage';
import AccountTransactionFlowPage  from './AccountTransactionFlowPage';
import VirtualAccountPage from './VirtualAccountPage';
import RealtimeSettlementOrderDailySumPage from './RealtimeSettlementOrderDailySumPage';
import RealtimeInvoiceClientListPage from './RealtimeInvoiceClientListPage';

const AccountManagementMainPage: React.FC = () => {
    const { t } = useTranslation();
    const hasTransQuery = hasResource([ResourceCode.settlement.SETTLEMENT_REALTIME_TRANS_QUERY]);
    const hasAccountStatement = hasResource([ResourceCode.settlement.SETTLEMENT_REALTIME_ACCOUNT_STATEMENT]);
    const hasBalance = hasResource([ResourceCode.settlement.SETTLEMENT_REALTIME_BALANCE]);
    const hasExportDetail = hasResource([ResourceCode.settlement.SETTLEMENT_REALTIME_EXPORT_DETAIL]);
    const hasInvoiceCheck = hasResource([ResourceCode.settlement.SETTLEMENT_REVENUE_BILL_CHECK]);

    const items = useMemo(() => {
        const tabs = [];
        if (hasTransQuery) tabs.push({
            label: t('settlement.accountManagement.tabs.transactionInquiry'),
            key: 'transaction-inquiry',
            children: <TransactionFlowPage />,
        });
        if (hasAccountStatement) tabs.push({
            label: t('settlement.accountManagement.tabs.accountStatement'),
            key: 'account-statement',
            children: <AccountTransactionFlowPage />,
        });
        if (hasBalance) tabs.push({
            label: t('settlement.accountManagement.tabs.accountBalance'),
            key: 'account-balance',
            children: <VirtualAccountPage />,
        });
        if (hasExportDetail) tabs.push({
            label: t('settlement.accountManagement.tabs.exportOrder'),
            key: 'export-order',
            children: <RealtimeSettlementOrderDailySumPage sumType={1} />,
        });
        if (hasInvoiceCheck) tabs.push({
            label: t('settlement.realtimeInvoice.tabs.invoice'),
            key: 'realtime-invoice',
            children: <RealtimeInvoiceClientListPage />,
        });
        return tabs;
    }, [t, hasTransQuery, hasAccountStatement, hasBalance, hasExportDetail, hasInvoiceCheck]);

    return (
        <div className="bg-white rounded-lg shadow-sm p-8">
            <Tabs 
                items={items} 
                size='large' 
                destroyInactiveTabPane={true}
            />
        </div>
    );
};

export default AccountManagementMainPage;

